import script from "./PeoplePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PeoplePage.vue?vue&type=script&setup=true&lang=js"

import "./PeoplePage.vue?vue&type=style&index=0&id=2055288c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2055288c"]])

export default __exports__